import { Children, ReactNode } from 'react'
import Markdown, { Components } from 'react-markdown'

/** GitHub-style heading slug (keeps accented letters), so doc anchors like `#solución-de-problemas` work. */
export const slugify = (text: string) =>
  text
    .toLowerCase()
    .trim()
    .replace(/[.,/#!$%^&*;:{}=_`~()"'?¿¡<>[\]|\\@+—–“”‘’]/g, '')
    .replace(/\s+/g, '-')

const textOf = (node: ReactNode): string =>
  Children.toArray(node)
    .map((c) => (typeof c === 'string' || typeof c === 'number' ? String(c) : ''))
    .join('')

const Heading = ({
  tag: Tag,
  children,
}: {
  tag: 'h1' | 'h2' | 'h3' | 'h4'
  children?: ReactNode
}) => <Tag id={slugify(textOf(children))}>{children}</Tag>

const components: Components = {
  h1: ({ children }) => <Heading tag="h1">{children}</Heading>,
  h2: ({ children }) => <Heading tag="h2">{children}</Heading>,
  h3: ({ children }) => <Heading tag="h3">{children}</Heading>,
  h4: ({ children }) => <Heading tag="h4">{children}</Heading>,
}

/** Renders markdown as formatted HTML with anchor ids on headings. */
export const MarkdownContent = ({ children }: { children: string }) => (
  <article className="space-y-4 text-gray-900 [&_a]:text-accent [&_a]:underline [&_blockquote]:border-l-4 [&_blockquote]:border-gray-300 [&_blockquote]:pl-4 [&_h1]:text-2xl [&_h1]:font-bold [&_h2]:mt-6 [&_h2]:text-lg [&_h2]:font-semibold [&_h3]:mt-4 [&_h3]:font-semibold [&_ol]:list-decimal [&_ol]:pl-6 [&_ul]:list-disc [&_ul]:pl-6">
    <Markdown components={components}>{children}</Markdown>
  </article>
)
